// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__tZ8+B","footerDisable":"Footer_footerDisable__SaUks","privacy":"Footer_privacy__v8RUU"};